<template>
    <a class="fixed -top-12 opacity-0 pointer-events-none" tabindex="-1"> </a>
</template>

<script>
export default {
    name: 'MainSkipToContentLink',
};
</script>

<style scoped></style>
